import { config } from '../config';
import { Setting } from '../interfaces';

const baseUrl = () => `${config.dealshakerPortalApiDomain}/api/Configurations`;

export const getAllConfigurations = () => config.requestInstance.get<Setting[]>(`${baseUrl()}/GetAll`);
